import { apolloClient } from "@/plugins/apollo";
import gql from "fraql";
import { buildMasterdataHelper } from "./factory";
export const MasterEventInfoCategoryFragment = gql `
  fragment _ on EventInfoCategory {
    id
    name
    nameTranslations {
      locale
      value
    }
    status
    rank
    template
    templateTranslations {
      locale
      value
    }
    description
    descriptionTranslations {
      locale
      value
    }
  }
`;
export function useEventInfoCategoryHelper() {
    function getEventInfoCategories() {
        var _a, _b;
        return ((_b = (_a = apolloClient.readQuery({
            query: gql `
          query MasterEventInfoCategories {
            eventInfoCategories {
              ${MasterEventInfoCategoryFragment}
            }
          }
        `
        })) === null || _a === void 0 ? void 0 : _a.eventInfoCategories) !== null && _b !== void 0 ? _b : []);
    }
    const { masterdataEntities, activeEntities, getFromMasterdata, addMissingSelectValue } = buildMasterdataHelper(getEventInfoCategories);
    return {
        masterEventInfoCategories: masterdataEntities,
        masterEventInfoCategoriesActive: activeEntities,
        getEventInfoCategoryFromMaster: getFromMasterdata,
        withMissingEventInfoCategorieselect: addMissingSelectValue
    };
}
